import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../state'

/**
 * Allows the user to select which packages to deploy
 */
@ngCore.Component({
  imports: [ds.table.Component],
  selector: 'atn-quiver-deployment-modal-packages-step',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.quiver.packages.Collection} */
  public readonly packagesEc = ngCore.inject(state.quiver.packages.Collection)

  /** Canonical embedded table input for selectable Quiver packages. */
  public readonly packagesTableConfig = {
    collection: this.packagesEc,
    view: {
      container: 'embedded' as const,
      search: true,
      selection: true,
    },
  } satisfies ds.table.ec.Config.Input<state.quiver.packages.TypeParams>
}
